export const resumeTimeline = [
 {
  id: 1,
  title: "LeetCode Problem Solving",
  organization: "LeetCode",
  location: "Competitive Programming",
  live:"https://leetcode.com/u/PRAVEEN_KUMAR-S",
  start: "2024",
  end: "Present",
  bullets: [
    "Solved 500+ coding problems across Data Structures and Algorithms",
    "Earned 7+ LeetCode badges through consistent problem-solving and contests",
    "Strengthened problem-solving skills in arrays, trees, graphs, DP, and greedy algorithms",
    "Practiced optimized solutions with focus on time and space complexity",
    "Maintained daily coding consistency and participated in coding challenges"
  ]
},
  {
  id: 2,
  title: "Open Source Contributor",
  organization: "Global Connect",
  location: "Remote",
  start: "2026/2",
  end: "3",
  
  bullets: [
    "Contributed to open-source projects through Global Connect collaborative initiatives",
    "Worked on feature improvements, bug fixes, and UI enhancements in community-driven projects",
    "Collaborated with developers in remote open-source environments using Git and GitHub workflows",
    "Participated in code reviews, issue discussions, and project maintenance activities"
  ]
},
  {
  id: 3,
  title: "DevOps & CI/CD Engineering",
  organization: "Personal Projects",
  location: "Remote",
  start: "2026",
  end: "Present",
  bullets: [
    "Designed and implemented CI/CD pipelines for full-stack MERN and Spring Boot applications",
    "Automated build, testing, and deployment workflows using Jenkins and Docker",
    "Containerized frontend and backend services for consistent development and deployment environments",
    "Worked with Kubernetes, Terraform, and AWS for scalable infrastructure and orchestration",
    "Integrated monitoring tools like Prometheus to improve application observability and performance tracking"
  ]
}
];
